import {Form} from "react-router-dom";
import Input from "../../../../react/components/ui/spectre/Input";
import {Satisfactory, SpecificFactoryData} from "../../../types";
import React from "react";

type Props = {
    factoryGameData: SpecificFactoryData<Satisfactory>,
    setFactoryGameData: (newFactoryGameData: SpecificFactoryData) => void,
    translateDialogue: (key: string) => string,
}

export function FactoryGameDataSatisfactory({ factoryGameData, setFactoryGameData, translateDialogue }: Props) {
    return <>
        <div>{translateDialogue('clockSpeed')}</div>
        <div>
            <Form onSubmit={e => e.preventDefault()} noValidate={true}>
                <Input type='number' step={0.01} min={1} max={2.500000}
                       onChange={(e) => !isNaN(e.target.valueAsNumber) && setFactoryGameData({clockSpeed: e.target.valueAsNumber})}
                       value={(factoryGameData as SpecificFactoryData<Satisfactory>).clockSpeed}/>
            </Form>
        </div>
    </>
}
